import React, { useState, useEffect, useCallback } from 'react';
import {
  IconButton, Grid, Chip, Button, Typography
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { debounce } from 'lodash';

// components
import { useHistory } from 'react-router-dom';
import PageTitle from '../../components/PageTitle';
import Widget from '../../components/Widget/Widget';
import TableData from '../../components/TableData';

import { useLayoutDispatch, toggleLoading } from '../../context/LayoutContext';
import useStyles from './styles';
import api from '../../services/api';
import { getError } from '../../utils/getResponseError';
import {
  cnpjMask
} from '../../utils/mask';

export default function Cobrancas() {
  const history = useHistory();
  const classes = useStyles();
  const [cobrancas, setCobrancas] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');
  const layoutDispatch = useLayoutDispatch();
  const [error, setError] = useState(null);

  useEffect(() => {
    cobrancaRequest();
  }, [page, search]);

  async function cobrancaRequest() {
    setError(null);
    toggleLoading(layoutDispatch);
    try {
      const { data } = await api.get(`/cobranca?pagina=${page}&nome=${search}`);
      setTotal(data.totalPaginas);
      setCobrancas(data.dados.map((item) => ({
        cliente: item.Cliente.nome,
        produto: item.Produto.nome,
        periodo: item.periodo,
        finalizado: item.terminado,
        id_cobranca: item.id_cobranca,
      })));
      if (page > data.totalPaginas) {
        setPage(1);
      }
    } catch (error) {
      setError(getError(error));
    }
    toggleLoading(layoutDispatch);
  }

  const handleSearch = (query) => {
    setSearch(query);
  };

  const onSearch = useCallback(
    debounce(handleSearch, 500),
    []
  );

  function handlePage(newPage) {
    if (newPage !== page) {
      setPage(newPage);
    }
  }

  function handleShow(index) {
    const cobranca = cobrancas[index];
    history.push(`/app/cobrancas/${cobranca.id_cobranca}`);
  }

  function handleReload() {
    cobrancaRequest();
  }

  return (
    <>
      <PageTitle
        title="Cobranças"
        button={(
          <IconButton
            color="primary"
            aria-label="cadastrar novo cliente"
            className={classes.addButton}
            onClick={() => history.push('/app/cobrancas/cadastro')}
          >
            <AddIcon />
          </IconButton>
        )}
      />
      {error && (
        <Grid container spacing={4}>
          <Grid
            item
            xs={12}

          >
            <Widget
              disableWidgetMenu
              style={{
                textAlign: 'center',
              }}
            >
              <Typography
                variant="h6"
                color="textSecondary"
                style={{
                  textAlign: 'center'
                }}
              >
                Ocorreu um erro ao tentar listar as cobrancas
              </Typography>
              <Typography
                variant="p"
                color="textSecondary"
                style={{
                  textAlign: 'center'
                }}
              >
                Mensagem de erro:
                {' '}
                {error}
              </Typography>
              <br />
              <Button
                variant="contained"
                color="primary"
                style={{
                  marginTop: 50
                }}
                onClick={handleReload}
              >
                Tentar novamente
              </Button>
            </Widget>
          </Grid>
        </Grid>
      )}
      {!error && (
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <TableData
              title="Cobranças cadastradas"
              columns={[{
                name: 'cliente',
                label: 'Cliente',
                options: {
                  filter: true,
                  sort: true,
                }
              },
              {
                name: 'produto',
                label: 'Produto',
                options: {
                  filter: true,
                  sort: false,
                }
              },
              {
                name: 'periodo',
                label: 'Periodo',
                options: {
                  filter: true,
                  sort: false,
                }
              },
              {
                name: 'finalizado',
                label: 'Estado',
                options: {
                  filter: true,
                  sort: false,
                  customBodyRender: (value) => (
                    <Chip
                      size="small"
                      label={value ? 'Terminado' : 'Em andamento'}
                      color={value ? 'default' : 'primary'}
                    />
                  )
                }
              }
              ]}
              data={cobrancas}
              search={onSearch}
              page={page}
              total={total}
              onSetPage={handlePage}
              onCloseSearch={setSearch}
              onDetails={handleShow}
              showDetails
              showSearch
            />
          </Grid>
        </Grid>
      )}
    </>
  );
}
